// Local imports
// polyfills must be applied before everything else
import '../../polyfill/index.js';

import * as basket from '../../basket/init.js';
import * as cart_datalayer from './datalayer.js';
import { push_data_object } from '../../datalayer/gtm/gtm_push.js';
import * as global_mod from '../../global/index.js';
import { PAGE_VARS, PageKind } from '../vars.js';
import * as tealium from '../../datalayer/tealium.js';

import * as shopify_data from './shopify_data.js';
import $ from 'jquery';

// --------------------------------------------------------------------------
// Module vars
// --------------------------------------------------------------------------
// Module name
export const MODULE_NAME = 'cart';

export let global_vars = {};

// --------------------------------------------------------------------------
// Functions
// --------------------------------------------------------------------------

class ShopifyData {
    constructor(data_element) {
        this.data_element = data_element;
    }

    shopify_recommend_data() {
        let all_datalayer = this.data_element.querySelectorAll('.datalayer');
        for (let el of all_datalayer) {
            const data = el.dataset;

            shopify_data.save_recommend_data(
                // donation_type
                {
                    id: data.id,
                    name: data.name,
                    category: `${data.category}/ /International`,
                },

                // position
                data.position,

                // collection_title
                'Recommended Donations Impressions List'
            );
        }
    }

    shopify_item_data() {
        let all_item = this.data_element.querySelectorAll('.item');
        for (let el of all_item) {
            const data = el.dataset;
            let item_title = data.title;
            shopify_data.save_item_data(
                // item
                {
                    id: data.id,
                    title: data.title,
                    price: data.price,
                    quantity: data.quantity,
                    brand: data.brand,
                    variant_sku: data.variant_sku,
                    variant_id: data.variant_id,
                    url: data.url,
                    category: data.category,
                    type: data.type,
                },

                // item_title
                item_title,

                // position
                data.position,

                // category
                data.category,

                // age
                data.age,

                // country
                data.country,

                // gender
                data.gender,

                // collection_title
                'list'
            );
        }
    }

    run() {
        this.shopify_recommend_data();
        this.shopify_item_data();
    }
}

class ProcessShopify {
    constructor(global, datacls) {
        let data_element = global.document.getElementById('cart-data');
        let data = data_element.dataset;
        this.global = global;
        this.data = data;
        this.shopify_data = new datacls(data_element);
    }

    shopify_error() {
        let data = this.data;

        if ('errormsg' in data && data.errormsg !== '') {
            throw new Error(data.errormsg);
        }
    }

    // If a spsh is NOT in the cart, remove the key 'SIEFLAG' from local storage, and
    // remove the element with id 'hidden_sie'
    sie_flag() {
        if (this.data.spsh_exists !== 'true') {
            if (typeof localStorage !== 'undefined') {
                localStorage.removeItem('SIEFLAG');
            }
            let hidden_sie = this.global.document.getElementById('hidden_sie');
            if (hidden_sie) {
                hidden_sie.remove();
            }
        }
    }

    remove_addon_link() {
        let item_count = parseInt(this.data.item_count);
        if (item_count <= 0) {
            return;
        }

        let addon_title = this.global.document.getElementById(
            'Title34694497996'
        );
        if (!addon_title) {
            return;
        }

        let addon = addon_title.closest('.basketCard-inner').closest('a');

        // Move nodes to new parent
        let new_parent = addon.parentElement;
        while (addon.childNodes.length) {
            new_parent.appendChild(addon.childNodes[0]);
        }

        // Remove old parent
        addon.remove();
    }

    analytics() {
        const SHOPIFY_DATA = shopify_data.SHOPIFY_DATA;

        // Recommend
        for (let d of SHOPIFY_DATA.recommend) {
            cart_datalayer.update_recommend_datalayer(
                d.donation_type,
                d.position,
                d.collection_title
            );
        }

        // Item
        for (let d of SHOPIFY_DATA.cart) {
            cart_datalayer.update_item_datalayer(
                d.item,
                d.position,
                d.category,
                d.age,
                d.country,
                d.gender,
                d.collection_title
            );
        }

        // Cart
        cart_datalayer.update_cart_datalayer(this.global);
    }

    run() {
        let global = this.global;
        let data = this.data;

        this.shopify_data.run();

        this.shopify_error(data);
        this.sie_flag(global, data);
        this.remove_addon_link(global, data);
        this.analytics(global);
    }
}

function init_pagevars() {
    PAGE_VARS.kind = PageKind.Cart;
    PAGE_VARS.action = 'checkout';
}

function init_handlers(global) {
    let cart = global.document.querySelector('#cart');

    // Don't do anything if there are no items in the cart
    if (cart === null) {
        save_continue_shopping_href(global);
        return;
    }

    let data = global.document.getElementById('cart-data').dataset;
    // Dont show Transaction Fees checkbox if there are Monthly products in cart
    if (
        global.document.querySelector('.orderForm-value--monthly').innerText ===
            '--' &&
        parseFloat(data.transaction_fees_percentage) !== 0
    ) {
        let cartTotal = global.document.querySelector('.orderForm-value--total')
            .innerText;
        let formattedCartTotal = Number(cartTotal.replace(/[^0-9.]+/g, ''));

        $('#transaction_fees_div').show();
        let transaction_fees_check = global.document.querySelector(
            '#include_transaction_fees'
        );

        // Show checked/unchecked
        transaction_fees_check.checked = data.transaction_fees_exist === 'true';

        // check/uncheck include transaction fees checkbox
        transaction_fees_check.addEventListener('change', e => {
            if (e.target.checked) {
                // Add transaction fees product to cart
                // Alvin change
                addTransactionFees(global, formattedCartTotal, data, 0);
            } else {
                // Remove transaction fees product from cart
                removeTransactionFees(global, data);
            }
        });
        //Function to show the tran fee for checkbox text and re add the transaction fee if checkbox is checked
        calculateTransactionFee(
            global,
            formattedCartTotal,
            data,
            transaction_fees_check.checked
        );
    } else {
        if (data.transaction_fees_exist === 'true') {
            // Remove transaction fees product from cart
            removeTransactionFees(global, data);
        }
    }

    // Remove Transaction fees if there are no other products in the cart
    if (data.transaction_fees_exist === 'true' && data.item_count === '1') {
        // Remove transaction fees product from cart
        removeTransactionFees(global, data);
    }

    cart.addEventListener(
        'submit',
        () => {
            cart_datalayer.update_cart_tocheckout_datalayer(global);
        },
        { once: true }
    );

    // Click on remove item link
    let all_remove_links = global.document.querySelectorAll(
        '.cartRemoveButton'
    );
    for (let link of all_remove_links) {
        link.addEventListener('click', event => {
            //Incase of removing the product from cart then get the bottom product mot code to assign to transaction fee
            setTransactionFeeMotCode();
            cart_datalayer.update_cart_remove_datalayer(
                global,
                event.currentTarget
            );
        });
    }

    // Click on quantity decrement button
    let all_decrement = global.document.querySelectorAll(
        '.quantityInput-control[data-increment-action="decrease"]'
    );
    for (let btn of all_decrement) {
        btn.addEventListener('click', event => {
            cart_datalayer.update_cart_zeroquantity_datalayer(
                global,
                event.currentTarget
            );
        });
    }

    // Add addon to cart
    cart_datalayer.update_cart_addon_datalayer(global);

    // Click on addon tile
    cart_datalayer.update_cart_addonclick_datalayer(global);
}

//Function to diplay the text for transaction fee checkbox and re-add incase of checkbox is checked
function calculateTransactionFee(
    global,
    formattedCartTotal,
    data,
    transactionFeeCheckFlag
) {
    let lblTranMessge = global.document.getElementById('lblMessage');
    //let data = global.document.getElementById('cart-data').dataset;
    // Remove $ and decimals and get only numbers
    let transactionProductAmount = 0;

    // Get Transaction fees product amount
    let all_item = global.document
        .getElementById('cart-data')
        .querySelectorAll('.item');

    for (let el of all_item) {
        const item_data = el.dataset;

        // Alvin change
        let item_id = item_data.id;
        if (item_id === data.transaction_fees_productid) {
            transactionProductAmount = parseInt(item_data.quantity);
            break;
        }
    }
    let transactionFeesAmount = Math.ceil(
        (formattedCartTotal - transactionProductAmount) *
            parseFloat(data.transaction_fees_percentage) +
            parseFloat(data.transaction_fees_top_up)
    );
    let text = lblTranMessge.innerText;
    lblTranMessge.innerText = text.replace(
        '{{transactionFee}}',
        transactionFeesAmount.toFixed(2)
    );
    //If trans fee checkbox is checked and transactionProductAmount, transactionFeesAmount not matches
    //then re add the transaction fee
    if (
        transactionFeeCheckFlag &&
        transactionProductAmount !== transactionFeesAmount
    ) {
        // Remove and Re-Add
        readdTransactionFees(
            global,
            data,
            formattedCartTotal,
            transactionFeesAmount
        );
    }
}

function readdTransactionFees(
    global,
    data,
    formattedCartTotal,
    transactionFeesAmount
) {
    let transactionFeesLine = data.transaction_fees_position;

    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: { line: transactionFeesLine, quantity: 0 },

        // `global` should be the window object when run in a browser
        success: () => {
            addTransactionFees(
                global,
                formattedCartTotal,
                data,
                transactionFeesAmount
            );
        },

        dataType: 'json',
    });
}

function addTransactionFees(
    global,
    formattedCartTotal,
    data,
    transactionFeesAmount
) {
    let productHandle = data.transaction_fees_product_handle;
    let transactionFeesPerc = parseFloat(data.transaction_fees_percentage);
    let transactionFeesTopup = parseFloat(data.transaction_fees_top_up);
    let language = global.document.body.dataset.lang;
    //Function to set the transaction fee mot code based on last product in cart
    setTransactionFeeMotCode();
    let request = $.get(
        '/products/' + productHandle + '?view=product-endpoint',
        response => {
            response = JSON.parse(response);
            let properties = response.metafields;
            let variantID = response.variantID;

            let orig_transactionfees = Math.ceil(
                formattedCartTotal * transactionFeesPerc + transactionFeesTopup
            );
            properties.amount =
                transactionFeesAmount === 0
                    ? orig_transactionfees
                    : transactionFeesAmount;
            //Assigned values for lang,type properties while adding transaction fee
            properties.lang = language;
            properties.type = 'SG';
            let data = new Object();
            data.id = variantID;
            //The price changed to $1 in proudct page so assigning the amount as quantity
            data.quantity = properties.amount;
            let renamedProperties = {};
            for (let [key, value] of Object.entries(properties)) {
            // If the properties does not have _ then only add _(underscore) to hide the properties in checkout page
                if(!key.startsWith('_')) {
                    renamedProperties['_' + key] = value;
                }
            }
            data.properties = renamedProperties;
            //Get the mot code from local strage to set for transation fee during adding
            data.properties._mot_code = localStorage.getItem('transFeeMotCode');
            data.properties._donation_quantity_fix = 'true';

            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,

                // `global` should be the window object when run in a browser
                success: () => {
                    global.location = '/cart';
                },

                dataType: 'json',
            });
        }
    );
    request.fail(() => {
        $('.basket-loadingOverlay').hide();
        $('.js-cannotBeFound').show();
    });
}
// Function call cart API to get the last product (not the latest) mot code from cart to assign to transaction fee mot code
function setTransactionFeeMotCode() {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        data: {},
        success: data => {
            let lastProductMotCode =
                data.items[data.items.length - 1].properties._mot_code;
            localStorage.setItem('transFeeMotCode', lastProductMotCode);
        },
        dataType: 'json',
    });
}
function removeTransactionFees(global, data) {
    let transactionFeesLine = data.transaction_fees_position;
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: { line: transactionFeesLine, quantity: 0 },

        // `global` should be the window object when run in a browser
        success: () => {
            global.location = '/cart';
        },

        dataType: 'json',
    });
}

function push_gtm_cart_data() {
    const SHOPIFY_DATA = shopify_data.SHOPIFY_DATA;
    //== gtm-push: Cart Items ==//
    let data_object = {
        event: 'view_cart',
        ecommerce: {
            items: [],
        },
    };

    for (let d of SHOPIFY_DATA.cart) {
        data_object.ecommerce.items.push({
            item_name: d.item.title,
            item_id: d.item.id,
            price: d.item.price,
            item_category: d.category,
            item_brand: d.item.brand,
            item_variant: d.item.variant_id,
            item_list_name: d.item.item_list_name,
            quantity: d.item.quantity,
            dimension20: d.gender,
            dimension21: d.country,
            dimension22: d.age,
            dimension23: d.item.variant_sku,
        });
    }
    push_data_object(data_object);
}

// Write hidden attribute fields for shopify
// to carry into checkout. Needed for thank you page data
function write_brand_attributes(global) {
    let remove_buttons = global.document.querySelectorAll('.cartRemoveButton');
    for (let btn of remove_buttons) {
        let dataset = btn.dataset;
        let brand_id_elements = global.document.getElementsByClassName(
            `${dataset.productid}_brand`
        );
        for (let i = 0; i < brand_id_elements.length; i++) {
            const element = brand_id_elements[i];
            element.value = dataset.brand;
        }
    }
}

// get last page visited and store main catgory page of product in href of continue shopping btn
function save_continue_shopping_href(global) {
    let btn = global.document.querySelector('.js-continue_shopping_btn');
    // store admin urls saved in hidden div
    let cat_url = global.document.querySelector('.js-store-index-url');
    let store_data = cat_url.dataset;
    // get last page visited for events app, rep id and bsb which adds directly to cart
    // hide btn if repid or bsb page - set href to previous url for events-app
    let history_href = global.document.referrer;
    btn_handler(history_href, btn, store_data);
}

function btn_handler(referrer, btn, store_data) {
    let new_href = '';
    let page_info = get_local_storage('continue_shopping');
    let regex_direct = new RegExp('repid|events-app|bsb', 'gi');
    let regex_osp = new RegExp('sponsorships', 'gi');
    let regex_ogc = new RegExp('gift[-]catalogue|cadeaux[-]durables', 'gi');
    let regex_col = new RegExp('collections', 'gi');
    let regex_odn = new RegExp('donations|dons', 'gi');
    let regex_products = new RegExp('products', 'gi');
    let regex_cart = new RegExp('cart', 'gi');

    // case 1: from direct link
    if (compare_url(referrer, regex_direct)) {
        if (btn_state_flag(referrer) && !hasClass(btn, 'u-hide')) {
            addHideClass(btn);
            new_href = store_data.odnCategoryUrl;
        } else {
            new_href = referrer;
        }
        // case 2: from Sponsorship page
    } else if (compare_url(referrer, regex_osp)) {
        new_href = store_data.ospCategoryUrl;
        // case 3: from ogc page
    } else if (compare_url(referrer, regex_ogc)) {
        new_href = store_data.ogcCategoryUrl;
        // case 4: from collections pages
    } else if (compare_url(referrer, regex_col)) {
        // from donation collection
        if (compare_url(referrer, regex_odn)) {
            new_href = store_data.odnCategoryUrl;
            // from other collection pages are ogc
        } else {
            new_href = store_data.ogcCategoryUrl;
        }
        // from product pages check localStorage for more info
        // case 5
    } else if (compare_url(referrer, regex_products)) {
        if (
            page_info.type === 'gift-catalogue' ||
            page_info.type === 'Gift Catalogue' ||
            page_info.type === 'cadeaux-durables'
        ) {
            new_href = store_data.ogcCategoryUrl;
        } else if (
            page_info.type === 'Donation' ||
            page_info.type === 'donations' ||
            page_info.type === 'dons'
        ) {
            new_href = store_data.odnCategoryUrl;
        } else {
            new_href = store_data.odnCategoryUrl;
        }
        // removing or adding items in cart - check localstorage
        // case 6
    } else if (compare_url(referrer, regex_cart)) {
        new_href = page_info.url;
        // all other pages take the odn category page
    } else {
        new_href = store_data.odnCategoryUrl;
    }
    replace_btn_attributes(btn, new_href);
    set_local_storage('continue_shopping', page_info, new_href);
}

function compare_url(referrer, regex) {
    let match = referrer.match(regex) !== null;
    return match;
}

function replace_btn_attributes(btn, link) {
    if (typeof link !== 'undefined') {
        btn.href = link;
    }
}

function get_local_storage(storage) {
    if (localStorage[storage]) {
        let obj = JSON.parse(localStorage.getItem(storage));
        return obj;
    }
}

function set_local_storage(storage, obj, value) {
    if (localStorage[storage]) {
        obj['url'] = value;
        localStorage.setItem(storage, JSON.stringify(obj));
    }
}

function btn_state_flag(string) {
    let regex = new RegExp('repid|bsb', 'gi');
    let flag = string.match(regex);
    return flag;
}

function hasClass(element, class_name) {
    let flag = false;
    if (element !== null) {
        flag = element.classList.contains(class_name);
    }
    return flag;
}

function addHideClass(element) {
    if (element !== null) {
        element.classList.add('u-hide');
    }
}

function initialize(global) {
    let process_shopify = new ProcessShopify(global, ShopifyData);
    process_shopify.run();

    init_handlers(global);
    push_gtm_cart_data();
    write_brand_attributes(global);
    save_continue_shopping_href(global);
}

export function main() {
    // Initialize all page vars
    init_pagevars();

    // Create object to pass to global initialization
    let all_modules = [];
    all_modules.push.apply(all_modules, global_mod.__all__);

    let cart_mod = {
        MODULE_NAME,
        global_vars,
        initialize,
    };

    all_modules.push(basket, cart_mod);

    // Insert datalayer setup module and tealium module at the beginning and end
    // of the modules array respectively
    all_modules = tealium.wrap_module_array(all_modules);

    // Initialize globals
    // The ``global`` global variable will be ``window`` when run in a browser
    // context.
    global_mod.initialize(global, all_modules);
}
